<script>
import SvgIcon from '~/components/SvgIcon.vue'

export default {
  name: 'DealerActionLink',
  components: { SvgIcon },
  props: {
    href: { type: String, required: true },
    icon: { type: [Object, String], required: true },
    width: { type: String, default: '24' },
    height: { type: String, default: '24' },
    text: { type: String, required: true },
    target: { type: String, default: '' }
  }
}
</script>

<template>
  <a
    :href="href"
    class="dealer-action-button"
    :target="target"
  >
    <SvgIcon
      v-if="typeof icon === 'object'"
      :src="icon"
      :width="width"
      :height="height"
    />
    <VIcon
      v-else
      color="primary"
      :size="width"
    >
      {{ icon }}
    </VIcon>
    <span class="font-weight-bold mt-2 dealer-action-button--text">
      {{ text }}
    </span>
  </a>
</template>

<style lang="scss">
.dealer-action-button {
  align-items: center;
  color: var(--v-primary-base) !important;
  display: flex;
  line-height: 20px;
  margin-top: 16px;
  flex-direction: column;
  text-decoration: none;
  font-size: 1.2rem;
  cursor: pointer;

  svg {
    color: var(--v-primary-base);
  }

  &--text {
    font-size: 11px
  }
}
</style>
